import { debounce } from 'lodash';
import { downloadFileById, exportK1 } from '../../../../shared/services/apiGateway';

export const handleFileDownload = async (fileId, currentManagedUserId = '', setLoadingDocuments) => {
  try {
    if (setLoadingDocuments) {
      setLoadingDocuments((prev) => ({ ...prev, [fileId]: true }));
    }
    const fileDownloadUrl = await downloadFileById(
      fileId,
      currentManagedUserId ? `?userid=${currentManagedUserId}` : '',
    );
    if (fileDownloadUrl && fileDownloadUrl.fileUrl) {
      window.open(fileDownloadUrl.fileUrl, '_blank');
    }
  } catch (error) {
    console.error('Error downloading file:', error);
  } finally {
    if (setLoadingDocuments) {
      setLoadingDocuments((prev) => ({ ...prev, [fileId]: false }));
    }
  }
};

export const handleDownloadK1File = debounce(async (fileKey, currentManagedUserId = '', setLoadingDocuments) => {
  try {
    if (setLoadingDocuments) {
      setLoadingDocuments((prev) => ({ ...prev, [fileKey]: true }));
    }
    // open new tab first to prevent popup blocker
    const newTab = window.open('', '_blank');
    newTab.document.write('Preparing K-1.');
    const response = await exportK1(currentManagedUserId ? `?userid=${currentManagedUserId}` : '', fileKey);
    if (response && response.fileUrl) {
      // open file url in the new tab once loaded
      newTab.location.href = response.fileUrl;
    } else {
      // response error, close tab
      newTab.close();
    }
  } catch (error) {
    console.error('Error downloading k1 file:', error);
  } finally {
    if (setLoadingDocuments) {
      setLoadingDocuments((prev) => ({ ...prev, [fileKey]: false }));
    }
  }
}, 375);
